import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { CustomHandler } from "@tCooneyBrothers/Handlers/CustomHandlerCreator";

type HandlerType = CustomHandler<{ cartFreightTerms: string }>;

export const DispatchSetFreightTerms: HandlerType = props => {
    props.dispatch({
        type: "Custom/CheckoutReview/SetFreightTerms",
        cartFreightTerms: props.parameter.cartFreightTerms,
    });
};

export const chain = [DispatchSetFreightTerms];

const setFreightTerms = createHandlerChainRunner(chain, "SetFreightTerms");
export default setFreightTerms;
